import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=36ae37b8&scoped=true&"
import script from "./basicSettings.vue?vue&type=script&lang=ts&"
export * from "./basicSettings.vue?vue&type=script&lang=ts&"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=36ae37b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae37b8",
  null
  
)

export default component.exports